/*! lineupjsx - v1.0.7 - 2018
* https://github.com/datavisyn/lineupjsx
* Copyright (c) 2018 Samuel Gratzl; Licensed MIT*/
!function (n, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("lineupjs"), require("react")) : "function" == typeof define && define.amd ? define(["lineupjs", "react"], t) : "object" == typeof exports ? exports.LineUpJS = t(require("lineupjs"), require("react")) : n.LineUpJS = t(n.LineUpJS, n.React);
}(window, function (n, t) {
  return function (n) {
    var t = {};

    function e(r) {
      if (t[r]) return t[r].exports;
      var u = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(u.exports, u, u.exports, e), u.l = !0, u.exports;
    }

    return e.m = n, e.c = t, e.d = function (n, t, r) {
      e.o(n, t) || Object.defineProperty(n, t, {
        enumerable: !0,
        get: r
      });
    }, e.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, e.t = function (n, t) {
      if (1 & t && (n = e(n)), 8 & t) return n;
      if (4 & t && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (e.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & t && "string" != typeof n) for (var u in n) {
        e.d(r, u, function (t) {
          return n[t];
        }.bind(null, u));
      }
      return r;
    }, e.n = function (n) {
      var t = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return e.d(t, "a", t), t;
    }, e.o = function (n, t) {
      return Object.prototype.hasOwnProperty.call(n, t);
    }, e.p = "", e(e.s = 4);
  }([function (t, e) {
    t.exports = n;
  }, function (n, e) {
    n.exports = t;
  }, function (n, t, e) {}, function (n, t, e) {}, function (n, t, e) {
    "use strict";

    e.r(t);
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var _r = function r(n, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (n, t) {
        n.__proto__ = t;
      } || function (n, t) {
        for (var e in t) {
          t.hasOwnProperty(e) && (n[e] = t[e]);
        }
      })(n, t);
    };

    function u(n, t) {
      function e() {
        this.constructor = n;
      }

      _r(n, t), n.prototype = null === t ? Object.create(t) : (e.prototype = t.prototype, new e());
    }

    var _i = function i() {
      return (_i = Object.assign || function (n) {
        for (var t, e = 1, r = arguments.length; e < r; e++) {
          for (var u in t = arguments[e]) {
            Object.prototype.hasOwnProperty.call(t, u) && (n[u] = t[u]);
          }
        }

        return n;
      }).apply(this, arguments);
    };

    var o = e(0),
        p = e(1),
        l = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n, t) {
        return o.builderAdapter.build(n);
      }, t;
    }(p.PureComponent),
        c = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n, t) {
        return o.builderAdapter.buildCategorical(n, t);
      }, t;
    }(l),
        d = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n) {
        return o.builderAdapter.buildDate(n);
      }, t;
    }(l),
        f = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n) {
        return o.builderAdapter.buildHierarchy(n);
      }, t;
    }(l),
        a = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n, t) {
        return o.builderAdapter.buildNumber(n, t);
      }, t;
    }(l),
        s = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n) {
        return o.builderAdapter.buildString(n);
      }, t;
    }(l),
        b = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n) {
        return o.builderAdapter.buildActions(n);
      }, t;
    }(l),
        h = function () {
      function n(n, t) {
        this.props = n, this.type = t;
      }

      return n.prototype.create = function () {
        return new this.type(this.props, null);
      }, n;
    }();

    function y(n, t) {
      return p.Children.toArray(n).filter(function (n) {
        return p.isValidElement(n) && o.builderAdapter.isTypeInstance(n.type, t);
      }).map(function (n) {
        return new h(n.props, n.type);
      });
    }

    var m = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t;
    }(p.PureComponent),
        g = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.merge = function (n) {
        var t = y(n.children, m).map(function (n) {
          return n.type.build(n.props);
        }),
            e = (n.columns || []).concat(t),
            r = _i({}, n, {
          columns: e
        });

        return delete r.children, r;
      }, t.build = function (n, t) {
        return o.builderAdapter.buildRanking(n, t);
      }, t;
    }(p.PureComponent),
        U = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = o.builderAdapter.buildGeneric, t;
    }(m),
        A = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = o.builderAdapter.buildImposeRanking, t;
    }(m),
        C = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n) {
        return o.builderAdapter.buildNestedRanking(n, y(n.children, U).map(function (n) {
          return n.type.build(n.props);
        }));
      }, t;
    }(m),
        v = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n) {
        return n.column;
      }, Object.defineProperty(t.prototype, "weight", {
        get: function get() {
          return this.props.weight;
        },
        enumerable: !0,
        configurable: !0
      }), t;
    }(m),
        L = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n) {
        var t = y(n.children, v);
        return o.builderAdapter.buildWeightedSumRanking(n, t.map(function (n) {
          return {
            weight: n.props.weight,
            column: n.type.build(n.props)
          };
        }));
      }, t;
    }(m),
        j = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n) {
        return o.builderAdapter.buildReduceRanking(n, y(n.children, U).map(function (n) {
          return n.type.build(n.props);
        }));
      }, t;
    }(m),
        w = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = function (n) {
        return o.builderAdapter.buildScriptRanking(n, y(n.children, U).map(function (n) {
          return n.type.build(n.props);
        }));
      }, t;
    }(m),
        S = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = o.builderAdapter.buildSupportRanking, t;
    }(m),
        O = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.build = o.builderAdapter.buildAllColumnsRanking, t;
    }(m),
        D = function (n) {
      function t() {
        var t = null !== n && n.apply(this, arguments) || this;
        return t.node = null, t.adapter = new o.builderAdapter.Adapter({
          props: function props() {
            return t.props;
          },
          createInstance: function createInstance(n, e) {
            return t.createInstance(t.node, n, e);
          },
          columnDescs: function columnDescs(n) {
            return y(t.props.children, l).map(function (t) {
              return t.type.build(t.props, n);
            });
          },
          rankingBuilders: function rankingBuilders() {
            return y(t.props.children, g).map(function (n) {
              return g.merge(n.props);
            });
          }
        }), t;
      }

      return u(t, n), t.prototype.createInstance = function (n, t, e) {
        return new o.LineUp(n, t, e);
      }, t.prototype.componentDidMount = function () {
        this.adapter.componentDidMount();
      }, t.prototype.componentDidUpdate = function (n) {
        var t = this.props;
        this.adapter.componentDidUpdate(function (e) {
          return !o.builderAdapter.equal(t[e], n[e]);
        });
      }, t.prototype.componentWillUnmount = function () {
        this.adapter.componentWillUnmount();
      }, t.prototype.render = function () {
        var n = this,
            t = this.props.className ? "lu-wrapper " + this.props.className : "lu-wrapper";
        return p.createElement("div", {
          className: t,
          style: this.props.style || {}
        }, p.createElement("div", {
          ref: function ref(t) {
            return n.node = t;
          }
        }));
      }, t;
    }(p.PureComponent),
        P = function (n) {
      function t() {
        return null !== n && n.apply(this, arguments) || this;
      }

      return u(t, n), t.prototype.createInstance = function (n, t, e) {
        return new o.Taggle(n, t, e);
      }, t;
    }(D);

    e(2), e(3);
    e.d(t, "version", function () {
      return _;
    }), e.d(t, "buildId", function () {
      return R;
    }), e.d(t, "license", function () {
      return x;
    }), e.d(t, "LineUp", function () {
      return D;
    }), e.d(t, "default", function () {
      return D;
    }), e.d(t, "ILineUpProps", function () {}), e.d(t, "Taggle", function () {
      return P;
    }), e.d(t, "LineUpColumnDesc", function () {
      return l;
    }), e.d(t, "LineUpCategoricalColumnDesc", function () {
      return c;
    }), e.d(t, "LineUpDateColumnDesc", function () {
      return d;
    }), e.d(t, "LineUpHierarchyColumnDesc", function () {
      return f;
    }), e.d(t, "LineUpNumberColumnDesc", function () {
      return a;
    }), e.d(t, "LineUpStringColumnDesc", function () {
      return s;
    }), e.d(t, "LineUpActionsColumnDesc", function () {
      return b;
    }), e.d(t, "ALineUpColumnBuilder", function () {
      return m;
    }), e.d(t, "LineUpColumn", function () {
      return U;
    }), e.d(t, "LineUpImposeColumn", function () {
      return A;
    }), e.d(t, "LineUpNestedColumn", function () {
      return C;
    }), e.d(t, "LineUpWeightedColumn", function () {
      return v;
    }), e.d(t, "LineUpWeightedSumColumn", function () {
      return L;
    }), e.d(t, "LineUpReduceColumn", function () {
      return j;
    }), e.d(t, "LineUpScriptedColumn", function () {
      return w;
    }), e.d(t, "LineUpSupportColumn", function () {
      return S;
    }), e.d(t, "LineUpAllColumns", function () {
      return O;
    }), e.d(t, "LineUpRanking", function () {
      return g;
    });
    var _ = "1.0.7",
        R = "20181108-111729",
        x = "MIT";
  }]);
});